export function hexToRgb(hex, asObject = false) {
    if (hex.startsWith("rgb")) {
        return asObject ? rgbStringToObj(hex) : hex;
    }
    let r = 0, g = 0, b = 0;
    // 3 digits
    if (hex.length == 4) {
        r = "0x" + hex[1] + hex[1];
        g = "0x" + hex[2] + hex[2];
        b = "0x" + hex[3] + hex[3];
        // 6 digits
    }
    else if (hex.length == 7) {
        r = "0x" + hex[1] + hex[2];
        g = "0x" + hex[3] + hex[4];
        b = "0x" + hex[5] + hex[6];
    }
    r = +r;
    g = +g;
    b = +b;
    return asObject ? { r, g, b } : "rgb(" + r + "," + g + "," + b + ")";
}
export function rgbStringToObj(rgb) {
    const sep = rgb.indexOf(",") > -1 ? "," : " ";
    // Turn "rgb(r,g,b)" into [r,g,b]
    const arr = rgb.substring(4).split(")")[0].split(sep);
    const r = (+arr[0]).toString(16), g = (+arr[1]).toString(16), b = (+arr[2]).toString(16);
    return { r: +r, g: +g, b: +b };
}
export function hexToHsl(hex, asObject = false) {
    return _rgbToHsl(hexToRgb(hex, true), asObject);
}
export function rgbToHsl(rgb, asObject = false) {
    return _rgbToHsl(rgbStringToObj(rgb), asObject);
}
export function _rgbToHsl(rgb, asObject = false) {
    let { r, g, b } = rgb;
    r /= 255;
    g /= 255;
    b /= 255;
    const cmin = Math.min(r, g, b), cmax = Math.max(r, g, b), delta = cmax - cmin;
    let h = 0, s = 0, l = 0;
    if (delta == 0)
        h = 0;
    else if (cmax == r)
        h = ((g - b) / delta) % 6;
    else if (cmax == g)
        h = (b - r) / delta + 2;
    else
        h = (r - g) / delta + 4;
    h = Math.round(h * 60);
    if (h < 0)
        h += 360;
    l = (cmax + cmin) / 2;
    s = delta == 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
    s = +(s * 100).toFixed(0);
    l = +(l * 100).toFixed(0);
    const obj = { h, s, l };
    return asObject ? obj : toHSLString(obj);
}
export function toHSL(color, asObject = false) {
    const rgb = hexToRgb(color, true); // converts to rgb or returns {r,g,b} from rgb()
    return _rgbToHsl(rgb, asObject);
}
export function toHSLString(hsl) {
    const { h, s, l } = hsl;
    return "hsl(" + h + "," + s + "%," + l + "%)";
}
//+15%  -25%
// 203 75 56
//# sourceMappingURL=colors.js.map